var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "check_more_department" },
    [
      _c("yxtbiz-dept-tree", {
        ref: "deptTree",
        staticClass: "department_tree",
        attrs: {
          version: "v1",
          openSelectSiblingNode: true,
          targetOrgId: _vm.targetOrgId,
          disabled: _vm.disabled,
          visibleOrgSelector: _vm.visibleOrgSelector,
          visibleOrgIds: _vm.visibleOrgIds,
          enableGroupCorp: _vm.enableGroupCorp,
          filterable: "",
          size: "small",
          placeholder: _vm.$t("biz_udp_enter_deptmentname"),
          "check-strictly": true,
          "show-checkbox": "",
          multiple: _vm.multiple,
          "children-included": 2,
          functions: !!_vm.childrenIncluded && _vm.functions,
          functionCode: _vm.functionCode,
          dataPermissionCode: _vm.dataPermissionCode,
          count: true,
          checkedLinkage: "1",
          teamId: _vm.teamId,
          core: "team",
          nodeKey: "id",
        },
        on: {
          "org-change": _vm.handleOrgChange,
          close: _vm.closeTag,
          check: _vm.handleCheck,
          clearNode: _vm.handleCheck,
          nodeClick: _vm.handleNodeClick,
          selectSiblingChange: _vm.selectSiblingChange,
          inited: _vm.init,
          includeChanged: _vm.handleTypeChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }